module.exports = __webpack_public_path__ + "static/media/check.acc5ea0b.png";